<template>
  <ul class="fuzzy-select-panel">
    <div class="tips" v-show="typeText.trim()">
      点击下方商品，即精准查询所点击商品
      <!-- 模糊搜索，选择下方的结果&emsp;
      <div class="check-all-btn" v-if="list.length" @click="checkAll">全选</div> -->
    </div>
    <div @scroll="loadMore" class="scroll">
      <template v-if="list.length">
        <li
          @click="handleSelectItem(item)"
          v-for="(item, index) in list"
          :key="index"
          :class="['panel-item', item.id == currentValue && 'active']"
        >
          {{ item.productName }} (ID: {{ item.id || item.productId }})
        </li>
      </template>
      <AgentEmpty
        v-if="!loading && !list.length"
        style="margin-top: 20px"
        msg="暂无相关搜索数据"
      />
    </div>
  </ul>
</template>

<script>
import { $shopApi } from '@/utils/http/modules/shop/shop.request'
import { isReachBottom } from '@/utils/utils'
import { GetLatestSearchContent } from '../../../utils/http/modules/agent/order'
import AgentEmpty from './AgentEmpty'
export default {
  name: 'FuzzySearchPanel',
  components: { AgentEmpty },
  props: {
    typeText: String,
    productId: [Number, String],
    fromType: [String],
  },
  data() {
    return {
      currentValue: '',
      list: [],
      loading: false,
      finished: false,
      listQuery: {
        ZbId: 0,
        sortBy: '',
        classId: 0,
        pageIndex: 1,
        pageSize: 20,
        NameOrId: '',
        storeDisplay: -1,
        state: -1,
      },
    }
  },
  computed: {
    searchResultProductIds() {
      return this.list.map(item => item.id || item.productId)
    },
  },
  watch: {
    typeText: {
      handler(val) {
        this.listQuery.NameOrId = val
        this.currentValue = ''
        this.handleSearch()
      },
      immediate: true,
    },
  },
  created() {
    this.listQuery.ZbId = window.zbvd.zbid
    this.currentValue = this.$props.productId || ''
    // this.getList()
  },
  methods: {
    async getList(type) {
      if (type == 'search') {
        this.list = []
        this.loading = false
        this.finished = false
      }
      if (this.loading || this.finished) return
      try {
        this.loading = true
        // 获取历史搜索记录
        const isGetLatestHistory = !this.typeText.trim()
        const api = isGetLatestHistory
          ? this.fromType != 'order'
            ? $shopApi.getLatestSearchProducts({
                zbId: window.zbvd.zbid,
                count: 10,
              })
            : GetLatestSearchContent({
                zbId: window.zbvd.zbid,
                source: 0,
                type: 0,
              })
          : $shopApi.getProList(this.getCommonParams())
        const { dataObj } = await api
        if (dataObj && dataObj.length) {
          let records = dataObj
          this.list = JSON.parse(JSON.stringify(this.list.concat(records)))
          if (dataObj.length < this.listQuery.pageSize || isGetLatestHistory) {
            this.finished = true
          } else {
            this.listQuery.pageIndex++
          }
        } else {
          this.finished = true
        }
        this.loading = false
      } catch (e) {
        this.finished = true
        this.loading = false
        e && this.$toast(e)
      } finally {
        this.$emit('getListSuccess', !this.loading)
      }
    },
    getCommonParams() {
      let params = {
        ...this.listQuery,
        zbId: window.zbvd.zbid,
      }
      return params
    },
    refreshList(type) {
      this.loading = false
      this.finished = false
      this.listQuery.pageIndex = 1
      this.getList(type)
    },
    handleSearch() {
      this.refreshList('search')
    },
    loadMore(event) {
      const dom = event.target
      isReachBottom(
        dom,
        () => {
          this.getList()
        },
        50
      )
    },
    handleSelectItem(item) {
      this.currentValue = item.id || item.productId
      this.listQuery.NameOrId = item.productName
      this.$emit('confirm', item)
    },
    checkAll() {
      const productIds = this.list.map(item => item.id || item.productId)
      this.$emit('check-all', productIds)
    },
  },
}
</script>

<style lang="scss" scoped>
.fuzzy-select-panel {
  display: flex;
  flex-direction: column;
  width: 355px;
  height: auto;
  background: #ffffff;
  box-shadow: 0 10px 60px 20px rgba(32, 33, 36, 0.08);
  border-radius: 12px;
  padding: 12px 16px 0;
  box-sizing: border-box;
  .tips {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: 400;
    font-size: 13px;
    color: #919499;
    line-height: 20px;
    text-align: left;
  }
  .panel-item {
    width: 100%;
    padding: 16px 0;
    box-sizing: border-box;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #202124;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    &.active {
      color: #006cff;
    }
    &:not(:last-of-type) {
      border-bottom: 1px solid #f5f6f7;
    }
  }
}
.scroll {
  width: 100%;
  max-height: 270px;
  min-height: 162px;
  overflow-y: auto;
}
::v-deep {
  .agent-empty {
    box-sizing: border-box;
    height: 100% !important;
  }
}
</style>
